import { render } from "./ReOrder.vue?vue&type=template&id=a4a7025a"
import script from "./ReOrder.vue?vue&type=script&lang=js"
export * from "./ReOrder.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__